import type { StudioForm } from './studio-api';
import type { StudioSettingSlot } from './StudioFormParts';
import { useStudioDocument } from './use-studio-document';
import {
  loadShootDicts,
  shootContext,
  shootKinds,
  shootLabels,
  shootRowChanged,
  shootRowValue,
  type ShootOverrides,
} from './studio-shoot-model';

/** Словари «Съёмки» одним кэшированным ответом для листа и карточки. */
export function useShootDicts(enabled = true) {
  return useStudioDocument(signal => (enabled ? loadShootDicts(signal) : Promise.resolve(null)), `studio-shoot-dicts:${enabled}`);
}
/** Ячейки блока «Съёмка» в карточке (§1.5, правило B1): только изменённые строки по порядку блока, ничего не меняли — «Съёмка · Авто».
    Лишние ячейки сворачивает в «+N» сама карточка (group: 'shoot'). */
export function shootCells(
  form: StudioForm | null | undefined,
  inputs: Record<string, string>,
  catalog: unknown,
  overrides?: ShootOverrides,
): StudioSettingSlot[] {
  const kinds = shootKinds(form, inputs);
  const context = shootContext(form, inputs, catalog, overrides);
  if (!kinds.length || !context) return [];
  const changed = kinds.filter(kind => shootRowChanged(context, kind));
  if (!changed.length) return [{ title: 'Съёмка', value: 'Авто', section: 'shoot', kind: 'cell' }];
  return changed.map(kind => ({
    title: shootLabels[kind],
    value: shootRowValue(context, kind, form?.screen),
    section: 'shoot',
    drill: `shoot:${kind}`,
    group: 'shoot',
    kind: 'cell' as const,
  }));
}
